import useApiService from 'services/api'
import { useUserOptions } from 'services/users'
import { Tag } from 'models/tags'
import BaseSelectModal, {
  BaseSelectModalProps,
} from './BaseSelectModal/BaseSelectModal'
import { bulkEditSingleParams } from 'services/apiTypes'
import { bulkUpdateDealReportsSingleField } from 'services/reports'

export default function AccountOwnerSelectModal({
  tableObjAccessor = 'account_owner',
  useReportsEndpoint = false,
  ...props
}: {
  tableObjAccessor?: string
  useReportsEndpoint?: boolean
} & Omit<
  BaseSelectModalProps<Tag>,
  | 'apiAction'
  | 'title'
  | 'subtitle'
  | 'label'
  | 'placeholder'
  | 'onConfirmAddNew'
  | 'items'
  | 'tableObjAccessor'
>) {
  const api = useApiService()
  const { data: accountOwners } = useUserOptions({
    onlyActive: true,
    withNoneOption: true,
    excludeLimited: true,
  })

  const apiAction = async (params: bulkEditSingleParams) => {
    const { item_id: account_owner, ...rest } = params
    // Use report-specific endpoint when called from deal reports table
    if (useReportsEndpoint) {
      return bulkUpdateDealReportsSingleField(
        { account_owner_id: account_owner },
        rest
      )
    }
    return api.bulkEditDeal({
      deal: { account_owner_id: account_owner },
      ...rest,
    })
  }

  if (!accountOwners) return null

  return (
    <BaseSelectModal
      {...props}
      title="Assign Account Owner"
      subtitle={
        <span>
          Add or replace the account owner for <b>all</b> selected rows.
        </span>
      }
      label="Name"
      placeholder="Select Account Owner"
      items={accountOwners}
      tableObjAccessor={tableObjAccessor!}
      apiAction={apiAction}
    />
  )
}
